import { AgentsNav } from '@components/agents/nav/AgentsNav';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useIsAgent } from '@components/hooks/isAgent';
import { dispatch, useSelector } from '@state/store';
import { getAgent } from '@state/slices/agent/agentSelectors';
import { clearAgent, fetchAgent, logoutAgent } from '@state/slices/agent/agentSlice';
import { usePrevious } from 'react-use';

export const AgentsNavContainer = () => {
  const isAgent: boolean = useIsAgent();
  const prevIsAgent = usePrevious(isAgent);
  const agent = useSelector(getAgent);
  const router = useRouter();
  const routerReady = router.isReady;

  useEffect(() => {
    if (isAgent) {
      if (routerReady) {
        dispatch(fetchAgent());
      }
    } else if (!isAgent && prevIsAgent) {
      dispatch(clearAgent());
    }
  }, [isAgent, routerReady]);
  const handleOnLogout = () => {
    dispatch(logoutAgent());
  };
  if (!agent.data.abta || !isAgent) return null;
  return <AgentsNav agent={agent.data} onLogout={handleOnLogout} />;
};
